import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useEffect } from "react";

import { ImageWithFallback } from "./ImageWithFallBack";

import InvalidImg from "@/assets/images/invalid-img.png";

type ImageCarouselProps = {
  srcArray: string[];
  handlePrevious: () => void;
  handleNext: () => void;
  currentIndex: number;
};

const ImageCarousel = (props: ImageCarouselProps): React.JSX.Element => {
  const { srcArray, handleNext, handlePrevious, currentIndex } = props;

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent): void => {
      if (e.key === "ArrowLeft") {
        handlePrevious();
      } else if (e.key === "ArrowRight") {
        handleNext();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return (): void => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleNext, handlePrevious]);

  return (
    <div className='w-full h-[80vh] flex items-center justify-center'>
      {srcArray.length > 1 && (
        <>
          <button
            onClick={handlePrevious}
            className='absolute p-2 transition-colors rounded-full left-4 bg-white/10 hover:bg-white/20'
            aria-label='Previous image'
          >
            <ChevronLeft className='w-6 h-6 text-white' />
          </button>

          <button
            onClick={handleNext}
            className='absolute p-2 transition-colors rounded-full right-4 bg-white/10 hover:bg-white/20'
            aria-label='Next image'
          >
            <ChevronRight className='w-6 h-6 text-white' />
          </button>
        </>
      )}

      <ImageWithFallback
        src={srcArray[currentIndex]}
        fallbackSrc={InvalidImg}
        alt={`Image ${currentIndex + 1}`}
        className='object-contain max-w-full max-h-full p-2 min-h-60 min-w-60'
      />

      {/* <button
  onClick={handleDownload}
  className='absolute p-2 transition-colors rounded-full bottom-4 right-4 bg-white/10 hover:bg-white/20'
  aria-label='Download image'
>
  <Download className='w-6 h-6 text-white' />
</button> */}

      <div className='absolute text-white transform -translate-x-1/2 bottom-4 left-1/2'>
        {currentIndex + 1} / {srcArray?.length}
      </div>
    </div>
  );
};

export default ImageCarousel;
